<template>
  <div
    class="pointer-events-auto w-full overflow-hidden rounded-md shadow-lg"
    :class="{
      'text-primary-contast bg-primary': isPrimary,
      'text-secondary-contast bg-secondary': isSecondary,
      'bg-black text-white': isNeutral,
      'text-info-contast bg-info': isInfo,
      'text-success-contast bg-success': isSuccess,
      'text-caution-contast bg-caution': isCaution,
      'text-warning-contast bg-warning': isWarning,
      'text-danger-contast bg-danger': isDanger,
    }"
  >
    <div class="p-4">
      <div class="flex items-center">
        <div class="ml-1 w-0 flex-1 pt-0.5">
          <p class="break-all text-white">
            {{ toast.message }}
          </p>
        </div>
        <div class="ml-4 flex flex-shrink-0">
          <button
            type="button"
            class="inline-flex rounded-xl text-white hover:text-opacity-80 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-1"
            @click="binToast(toast)"
          >
            <span class="sr-only">Close</span>
            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWidgetStore, IToast, AlertTypes } from "@src/stores/WidgetStore";
import { XMarkIcon } from "@heroicons/vue/20/solid";
import { toRefs, computed, ref } from "vue";

const props = defineProps<{
  toast: IToast;
}>();

const { toast } = toRefs(props);

const isVisible = ref(false);

const { binToast } = useWidgetStore();

if (!!toast.value.autoDismiss)
  setTimeout(() => binToast(toast.value), toast.value.autoDismiss);

const isPrimary = computed(() => toast.value.type === AlertTypes.PRIMARY);
const isSecondary = computed(() => toast.value.type === AlertTypes.SECONDARY);
const isInfo = computed(() => toast.value.type === AlertTypes.INFO);
const isNeutral = computed(() => toast.value.type === AlertTypes.NEUTRAL);
const isSuccess = computed(() => toast.value.type === AlertTypes.SUCCESS);
const isCaution = computed(() => toast.value.type === AlertTypes.CAUTION);
const isWarning = computed(() => toast.value.type === AlertTypes.WARNING);
const isDanger = computed(() => toast.value.type === AlertTypes.DANGER);
</script>
